import React from 'react';

// Data
import { buildUpdateAssessment, getAssessment } from '../../../lib/services/assessment.service';

// Components
import { UpdateAssessmentContainer } from './update-assessment.container';
import { AgeGroupJerseyRetentionSettings } from '../../JerseyAssignment/age-group-jersey-retention.component';
import { canEditAttendanceDefault } from '../../Attendance/attendance.permissions';
import { getAuthUser } from '../../../lib/services/auth.service';
import { getActiveCompanyId, getCompany } from '../../../lib/services/company.service';

export const UpdateAssessmentGraphQL = () => {
  const user = getAuthUser();

  const companyId = getActiveCompanyId();
  const { company } = getCompany(companyId);

  const { updateAssessment } = buildUpdateAssessment();
  const { assessment } = getAssessment(user?.settings.activeAssessmentId);
  // Age groups are a retention level only CONFIGURATION sets, like the assessment's own setting above.
  const canEditSettingDefaults = canEditAttendanceDefault();

  return <>
    <UpdateAssessmentContainer
      assessment={assessment}
      company={company}
      updateAssessment={updateAssessment}
    />
    {canEditSettingDefaults && <AgeGroupJerseyRetentionSettings
      assessmentId={user?.settings.activeAssessmentId}
      assessmentRetains={Boolean(assessment?.retainJerseyAssignments ?? company?.retainJerseyAssignments)}
    />}
  </>;
};
